import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../shared/util/util';
import {trackEvent} from '../../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../../mutations/MutationTypes';
import {
	SetBaselineTemplateActiveInput,
	SetBaselineTemplateActiveMutation,
} from './__generated__/SetBaselineTemplateActiveMutation.graphql';

const mutation = graphql`
	mutation SetBaselineTemplateActiveMutation($input: SetBaselineTemplateActiveInput!) {
		setBaselineTemplateActive(input: $input) {
			baselineTemplate {
				id
				active
				updatedAt
			}
			company {
				id
				...BaselineTemplatesList_company
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<SetBaselineTemplateActiveInput>,
	onSuccess?: RelayOnCompleted<SetBaselineTemplateActiveMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<SetBaselineTemplateActiveMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Template', input.active ? 'Reactivated' : 'Deactivated');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
